// AdminPanel/AccountStatusTab: the customers in one account status, trial by
// default (every self-signup org starts in trial). Loads only that status
// from the server; the Customers tab loads every org.
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Alert, Box, CircularProgress, MenuItem, TextField, Typography} from '@mui/material';

import {listOrgsByAccountStatus} from '../../actions/adminPanel';
import Table from '../../components/Table';
import customerColumns from './customerColumns';

export const ACCOUNT_STATUSES = ['trial', 'active', 'testing', 'blocked', 'terminated'];

const AccountStatusTab = ({onOpenOrg}) => {
  const [accountStatus, setAccountStatus] = useState('trial');
  const [orgs, setOrgs] = useState(null); // null while loading
  const [error, setError] = useState('');

  useEffect(() => {
    let current = true;
    setOrgs(null);
    setError('');
    listOrgsByAccountStatus(accountStatus)
      .then((rows) => current && setOrgs(rows))
      .catch(() => {
        if (current) {
          setOrgs([]);
          setError('Could not load the accounts. Please try again.');
        }
      });
    return () => {
      current = false;
    };
  }, [accountStatus]);

  return (
    <div>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 2, mb: 2}}>
        <TextField
          select
          size="small"
          label="Account status"
          value={ accountStatus }
          onChange={ (e) => setAccountStatus(e.target.value) }
          sx={{minWidth: 200}}>
          {ACCOUNT_STATUSES.map((s) => <MenuItem key={ s } value={ s }>{s}</MenuItem>)}
        </TextField>
        {orgs === null ?
          <CircularProgress size={ 20 } /> :
          <Typography variant="body2">{orgs.length} {accountStatus} account{orgs.length === 1 ? '' : 's'}</Typography>}
      </Box>
      {error ? <Alert severity="error" sx={{mb: 2}}>{error}</Alert> : null}
      {orgs && orgs.length > 0 ?
        <Table
          column={ customerColumns(onOpenOrg) }
          serialNumber
          data={ orgs }
          showPagination
          pageOptions={ [100, 200, 500] }
          defaultPageSize={ 100 } /> :
        null}
    </div>
  );
};

AccountStatusTab.propTypes = {
  onOpenOrg: PropTypes.func.isRequired
};

export default AccountStatusTab;
